import { render } from "./TabLinked.vue?vue&type=template&id=64217ed0"
import script from "./TabLinked.vue?vue&type=script&setup=true&lang=js"
export * from "./TabLinked.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/TabLinked.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64217ed0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64217ed0', __exports__)) {
    api.reload('64217ed0', __exports__)
  }
  
  module.hot.accept("./TabLinked.vue?vue&type=template&id=64217ed0", () => {
    api.rerender('64217ed0', render)
  })

}


export default __exports__